<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      :show-save-button="!readonly"
      title="管理宿舍"
      id-key="TeacherId"
      :data="data"
      form-label-width="100px"
      @edit-opened="onEditOpened"
      :save-func="api.saveDormitorys"
      :before-save="onBeforeSave"
      :get-data-func="api.getDormitorys"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <div class="row-tb-head">
              <span>管理宿舍列表</span>
              <div style="float: right;" v-if="!readonly">
                <el-button type="primary" icon="el-icon-plus" @click="addDorm">添加</el-button>
                <el-button type="danger" @click="delDorms">删除</el-button>
              </div>
            </div>
            <el-table ref="tb_dorm" class="tb-c-head" :data="tableData" border>
              <el-table-column type="selection" width="40px" align="center" />
              <el-table-column label="地址" prop="DormitoryAddr" />
              <el-table-column label="楼层" prop="DormitoryFloor" />
              <el-table-column label="宿舍号" prop="DormitoryNumber" />
              <el-table-column label="操作" align="center" fixed="right" width="60px" v-if="!readonly">
                <template slot-scope="{row,$index}">
                  <el-button type="text" @click="del(row,$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer" v-if="readonly">
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <dorm-dialog ref="dormDialog" in-dialog selectable multiple @select-multiple="setDorms" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import dormDialog from "@/components/lo/dorm/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dormDialog
  },
  data() {
    return {
      api: require("@/api/fa/teacher").default,
      isMB: this.$store.state.isMB,
      readonly: !this.$permission.canWrite(),
      data: {
        TeacherId: null,
        TeacherName: "",
        Dormitorys: [],
      },
      tableData: [],
      delList: [],
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      data.Dormitorys.forEach(e => {
        e.T = 1;
      })
      this.tableData = data.Dormitorys;
    },
    addDorm() {
      this.$refs.dormDialog.open().then((that) => {
        that.getData();
      });
    },
    setDorms(dorms) {
      if(dorms.length == 0) return;
      var same = [];
      dorms.forEach(e => {
        var obj = this.tableData.find(x => {
          return x.DormitoryId == e.DormitoryId;
        })
        if(obj) {
          same.push(e.DormitoryNumber);
        } else {
          this.tableData.push({
            DormitoryEmpId: 0,
            DormitoryId: e.DormitoryId,
            EmpId: this.data.TeacherId,
            TeacherId: this.data.TeacherId,
            TeacherName: this.data.TeacherName,
            DormitoryNumber: e.DormitoryNumber,
            DormitoryFloor: e.DormitoryFloor,
            DormitoryAddr: e.DormitoryAddr,
            T: 0,
          });
        }
      })
      if(same.length) {
        this.$message.error("已存在相同的宿舍号：" + same.join("，"));
      }
    },
    delDorms() {
      var rows = this.$refs.tb_dorm.selection;
      if(rows.length==0) {
        this.$message.error("请选择要删除的数据");
        return;
      }
      var ids = rows.map(x => x.DormitoryId);
      ids.forEach(e => {
        var obj = this.tableData.find(x => x.DormitoryId == e);
        var index = this.tableData.findIndex(x => x.DormitoryId == e);
        if(index > -1) {
          this.del(obj,index);
        }
      })
    },
    del(row,index) {
      if(!(row.T===0)) {
        row.T = 2;
        this.delList.push(row);
      }
      this.tableData.splice(index,1);
    },
    onBeforeSave() {
      var td = this.tableData;
      var dl = this.delList;
      this.data.Dormitorys = td.concat(dl);
    },
    onClosed() {
      this.tableData = [];
      this.delList = [];
    },
  },
};
</script>